import { FunctionComponent } from 'react';
import cn from 'classnames';
import { ProductTypeSize } from '@/types';
import { trackFeature } from '@/utils/adobeLaunch';
import { t } from '@/utils/i18n';
import { QuantitySelector } from '@/components/common/QuantitySelector';

interface Props {
  size: ProductTypeSize;
  name: string;
  currentQuantity?: number;
  available: boolean;
  onChange: (sizeId: string, quantity: number) => void;
}

export const SizeSelector: FunctionComponent<Props> = ({
  size,
  name,
  currentQuantity = 0,
  available,
  onChange,
}) => {
  const handleChange = (quantity: number) => {
    onChange(size.id, quantity);
  };
  return (
    <QuantitySelector
      inputId={size.id}
      className={cn('size-selection__size', { 'size-selection__size--disabled': !available })}
      labelClassName="size-selection__size-name ellipsis"
      quantity={currentQuantity || 0}
      onChange={handleChange}
      disabled={!available}
      ariaLabel={t('sizePanel.quantity', name)}
      decreaseLabel={
        currentQuantity > 0 ? t('sizePanel.decrease', name, String(currentQuantity - 1)) : ''
      }
      increaseLabel={t('sizePanel.increase', name, String(currentQuantity + 1))}
      trackingIncreaseFn={() => trackFeature('size-selection-increase-quantity')}
      trackingDecreaseFn={() => trackFeature('size-selection-decrease-quantity')}
    >
      {name}
    </QuantitySelector>
  );
};
